import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {Avatar, Divider, Icon, List, ListItem, ListItemText, Paper, Typography} from '@material-ui/core';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseAnimate} from '@fuse';
import {bindActionCreators} from "redux";
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import thousandSeparators from "../../../../helper/format";

const styles = theme => ({
    listItem: {
        color: 'inherit!important',
        textDecoration: 'none!important',
        height: 40,
        width: 'calc(100% - 16px)',
        borderRadius: '0 20px 20px 0',
        paddingLeft: 24,
        paddingRight: 12,
        '&.active': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText + '!important',
            pointerEvents: 'none',
            '& .list-item-icon': {
                color: 'inherit'
            }
        }
    }
});

class UseRecordSideBar extends Component {

    isEmpty() {

        const sidebarTypeMap = {
            'vip': {
                type: 'vip',
                value: this.props.user
            },
            'group': {
                type: 'group',
                value: this.props.group
            },
            'company': {
                type: 'company',
                value: this.props.company
            }
        };

        const value = sidebarTypeMap[this.props.sidebarType].value;
        return !(value);
    }

    getInfoPanel = () => {

        const {user, group, company} = this.props;

        if (this.props.sidebarType === 'vip')
            return (
                <div className="p-24 flex items-center">
                    <Avatar className="mr-12" alt={user.name} src={user.avatar.url}/>
                    <Typography>{user.name}</Typography>
                </div>
            );

        else if (this.props.sidebarType === 'group')
            return (
                <div className="p-24 flex items-center">
                    <Icon className="mr-12" color="action">
                        group
                    </Icon>
                    <Typography>{group.name}</Typography>
                </div>
            );

        else if (this.props.sidebarType === 'company')
            return (
                <div className="p-24 flex items-center">
                    <Icon className="mr-12" color="action">
                        business
                    </Icon>
                    <Typography>{company.name}</Typography>
                </div>
            );

        else return <div/>;
    }

    render() {
        const {classes, setSidebarSearchText, vip} = this.props;

        if (this.isEmpty()) return <div/>;

        return (
            <div className="p-16 lg:p-24 lg:pr-4">
                <FuseAnimate animation="transition.slideLeftIn" delay={200}>
                    <Paper elevation={1} className="rounded-8">
                        {this.getInfoPanel()}
                        <Divider/>
                        <List>
                            <ListItem
                                button
                                onClick={() => {
                                    setSidebarSearchText({target: {value: 'only_add'}});
                                }}
                                className={classes.listItem}
                            >
                                <Icon className="list-item-icon text-16" color="action">
                                    add
                                </Icon>
                                <ListItemText
                                    className="truncate pr-0"
                                    primary="加點查詢"
                                    disableTypography={true}/>
                            </ListItem>
                            <ListItem
                                button
                                onClick={() => {
                                    setSidebarSearchText({target: {value: 'only_minus'}});
                                }}
                                className={classes.listItem}
                            >
                                <Icon className="list-item-icon text-16" color="action">
                                    remove
                                </Icon>
                                <ListItemText
                                    className="truncate pr-0"
                                    primary="扣點查詢"
                                    disableTypography={true}/>
                            </ListItem>

                            {vip.group &&  <ListItem
                                button
                                onClick={() => {}}
                                className={classes.listItem}
                            >
                                <Typography variant="subheading" color="inherit" >
                                    剩餘
                                </Typography>
                                <ListItemText
                                    className="truncate pr-0 text-16"
                                    primary={`${thousandSeparators(vip.group.current_point)} 點`}
                                    disableTypography={true}/>
                            </ListItem>}

                        </List>
                    </Paper>
                </FuseAnimate>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSidebarSearchText: ReduxGlobal.ActionCreator.setSidebarSearchText,
    }, dispatch);
}

function mapStateToProps({auth, vip: {vip}, group: {group}, company: {company}}) {

    const user = {
        name: (vip.user) ? vip.user.name : auth.user.data.displayName,
        avatar: {
            url: (vip.user) ? vip.user.avatar.url : auth.user.data.photoURL,
        }
    };

    return {user, group, company, vip};
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(UseRecordSideBar)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/UseRecordSideBar.js